export default __webpack_public_path__ + "static/media/TCInfo.6eb03334.md";